import Chart from 'chart.js/auto';
import { debounce } from '@/utilities/helpers';

export const initDoughnutChart = ($chart) => {

    let rotation = 180;

    let dataset = JSON.parse($chart.dataset.dataset);
    dataset = dataset[0];
    let colour = $chart.dataset.colour;

    let gradient_purple_dark = $chart.getContext('2d').createLinearGradient(0, 142, 0, 0);
    gradient_purple_dark.addColorStop(1, '#b88fe8');
    gradient_purple_dark.addColorStop(0, '#7c54a9');

    let gradient_purple_light = $chart.getContext('2d').createLinearGradient(0, 142, 0, 0);
    gradient_purple_light.addColorStop(1, '#eae5f2');
    gradient_purple_light.addColorStop(0, '#eae5f2');

    let gradient_green_dark = $chart.getContext('2d').createLinearGradient(0, 142, 0, 0);
    gradient_green_dark.addColorStop(1, '#DCEEAB');
    gradient_green_dark.addColorStop(0, '#669E02');

    let gradient_green_light = $chart.getContext('2d').createLinearGradient(0, 142, 0, 0);
    gradient_green_light.addColorStop(1, '#E6EFD6');
    gradient_green_light.addColorStop(0, '#E6EFD6');

    let green_stripe_overlay = $chart.getContext('2d').createLinearGradient(0, 0, 142, 0);
    let iterator = 0;
    let isWhiteStripe_green = false;

    while (iterator < 0.9) {
        const background_colour = isWhiteStripe_green ? '#fff' : '#ADCE68';
        const step = isWhiteStripe_green ? 0.00758 : 0.02;
        green_stripe_overlay.addColorStop(iterator, background_colour);
        green_stripe_overlay.addColorStop(iterator + step, background_colour);
        iterator += step;
        isWhiteStripe_green = !isWhiteStripe_green;
    }

    let purple_stripe_overlay = $chart.getContext('2d').createLinearGradient(0, 0, 142, 0);
    let purple_iterator = 0;
    let isWhiteStripe_purple = false;

    while (purple_iterator < 0.9) {
        const background_colour = isWhiteStripe_purple ? '#fff' : '#704C99';
        const step = isWhiteStripe_purple ? 0.00758 : 0.02;
        purple_stripe_overlay.addColorStop(purple_iterator, background_colour);
        purple_stripe_overlay.addColorStop(purple_iterator + step, background_colour);
        purple_iterator += step;
        isWhiteStripe_purple = !isWhiteStripe_purple;
    }

    let greys = [
        '#889DA2',
        '#EEF0F2'
    ];

    let purple_gradients = [
        gradient_purple_dark,
        gradient_purple_light
    ];

    let green_gradients = [
        gradient_green_dark,
        gradient_green_light
    ];

    let colours = greys;
    if (colour === 'purple') colours = purple_gradients;
    if (colour === 'green') colours = green_gradients;

    dataset.data = dataset.data.map((value, index) => {
        if (index === 0) return parseFloat(value) || 0;
        return parseFloat((dataset.data[0] - value).toFixed(2));
    });

    // If the first item is a negative number change its colour to the green stripe overlay
    if (dataset.data[0] < 0 && colour === 'green') {
        [dataset.data[0], dataset.data[1]] = [dataset.data[1], dataset.data[0]];
        colours[0] = gradient_green_light;
        colours[1] = green_stripe_overlay;
    }

    // If the first item is a negative number change it's colour to the purple stripe overlay
    if (dataset.data[0] < 0 && colour === 'purple') {
        [dataset.data[0], dataset.data[1]] = [dataset.data[1], dataset.data[0]];
        colours[1] = gradient_purple_light;
        colours[0] = purple_stripe_overlay;
    }

    let data = {
        labels: dataset.labels,
        datasets: [{
            data: dataset.data,
            backgroundColor: colours
        }]
    };

    let chart = new Chart($chart, {
        type: 'doughnut',
        data,
        options: {
            responsive: true,
            layout: { padding: 0 },
            plugins: {
                legend: { display: false },
                tooltip: { enabled: false },
                datalabels: { display: false }
            },
            rotation,
            borderWidth: 0,
            cutout: '60%',
        }
    });

    window.addEventListener('resize', debounce(() => chart.resize(), 300));

}